import React from 'react';
import NFlightWeb from './NflightWeb';
import { ConsentManagementWrapper } from './util/consentManagement';

class App extends React.Component {

  render() {
    return (
      <ConsentManagementWrapper>
        <NFlightWeb />
      </ConsentManagementWrapper>
    );
  }
}

export default App;